import React from 'react';
import Diagnosis from '../../Diagnosis/Diagnosis';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import Progress from 'src/components/ServiceRequestForm/Progress/Progress';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import RoomAccordionList from 'src/components/RoomAccordionList/RoomAccordionList';
import RoomAssets from 'src/components/ServiceRequestForm/RoomAssets/RoomAssets';
import Callout from 'src/components/InformationCallout/Callout';
import { variables } from 'src/Tenants';
import {
  useServiceRequestFormAssetOrchestrator,
  UseServiceRequestFormAssetOrchestratorReturn,
} from './useServiceRequestFormAssetOrchestrator';
import './ServiceRequestFormAsset.scss';

const expiredWarrantyMessage: string = `The highlighted assets are past their
warranty end date, so a service request can't be submitted for them. Please
contact your ${variables.developer.toLowerCase()}'s support team to have this
warranty expiration looked into.`;

const ServiceRequestFormAsset = () => {
  const {
    formData,
    assets,
    diagnosisAsset,
    diagnosisIssueType,
    warrantyExpiresAt,
    expandedRoom,
    hasExpiredAssets,
    floorplanUrl,
    hasViewableFloorplan,
    isLightboxOpen,
    nextButtonLabel,
    isCheckingFaqs,
    canProceed,
    patchFormData,
    loadFaqsForAsset,
    onToggleRoom,
    onViewFloorplan,
    closeLightbox,
    onNext,
    onBack,
    onExit,
  }: UseServiceRequestFormAssetOrchestratorReturn =
    useServiceRequestFormAssetOrchestrator();

  return (
    <ServiceRequestFormDialog
      title="Let's Identify the Issue"
      description="Tell us what's happening and we'll be able to find the right solution to get things back to normal."
      onBack={onBack}
      onExit={onExit}
      footer={
        <LoadingButton
          actionText={isCheckingFaqs ? 'Loading...' : nextButtonLabel}
          isSubmitting={isCheckingFaqs}
          disabled={!canProceed}
          onClick={onNext}
        />
      }
    >
      <Diagnosis
        asset={diagnosisAsset}
        issueType={diagnosisIssueType}
        expiresAt={warrantyExpiresAt}
        location={undefined}
        label={undefined}
      />
      <Progress currentStep={0} totalSteps={3} />

      {hasViewableFloorplan && (
        <div className="sr-form-asset-floorplan-link" onClick={onViewFloorplan}>
          View Floorplan
        </div>
      )}

      {isLightboxOpen ? (
        <ReusableLightbox
          isOpen={isLightboxOpen}
          onClose={closeLightbox}
          image={floorplanUrl}
        />
      ) : null}

      {hasExpiredAssets && (
        <Callout
          variant="error"
          size="small"
          title="Some assets are no longer under warranty"
          subtitle={expiredWarrantyMessage}
        />
      )}

      <RoomAccordionList
        rooms={assets}
        expandedRoom={expandedRoom}
        onToggleRoom={onToggleRoom}
        renderRoomContent={(room) => (
          <RoomAssets
            rooms={room.assets}
            room={room}
            serviceRequestFormData={formData}
            onSetServiceRequestFormData={patchFormData}
            onFetchFaqsNotesDocuments={loadFaqsForAsset}
          />
        )}
      />
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormAsset;